module.exports = __webpack_public_path__ + "media/images/badges/yogasix/inactive/Y6Warrior2022_Badges_4500_Inactive@1x-a746d88e7edfb7cd8a8416d13f6cd1fb.png";